
import * as React from 'react';
import { Omit } from '../Omit';

export interface IComponentDecorator<TInjectedProps, TOwnProps, TBaseProps = {}> {
    <P extends TInjectedProps & TBaseProps>(component: React.ComponentType<P>): IDecoratedComponentType<P, TInjectedProps, TOwnProps>;
}

export interface ISimpleComponentDecorator<TOwnProps, TBaseProps = {}> {
    <P extends TBaseProps>(component: React.ComponentType<P>): ISimpleDecoratedComponentType<P, TOwnProps>;
}

export type IDecoratedProps<TOriginalProps extends TInjectedProps, TInjectedProps, TOwnProps> =
    Omit<TOriginalProps, keyof TInjectedProps> & TOwnProps;

export type ISimpleDecoratedProps<TOriginalProps, TOwnProps> =
    TOriginalProps & TOwnProps;

export type IDecoratedComponentType<TOriginalProps extends TInjectedProps, TInjectedProps, TOwnProps> =
    React.ComponentType<IDecoratedProps<TOriginalProps, TInjectedProps, TOwnProps>>;

export type ISimpleDecoratedComponentType<TOriginalProps, TOwnProps> =
    React.ComponentType<TOriginalProps & TOwnProps>;

export function withDisplayName(displayName: string): <C extends {}>(component: C) => C {
    return <C extends {}>(component: C & { displayName?: string; }) => {
        if (component.displayName) {
            component.displayName = `${displayName}(${component.displayName})`;
        } else {
            component.displayName = displayName;
        }

        return component;
    };
}
